// src/components/TarjetaResenasClientes.jsx
// Tarjeta compacta de prueba social ("Reseñas de clientes ⭐"), compartida
// entre la sección de vuelos pública (sin login) y la de dentro de la app
// (logueado) -- visible solo cuando "Nuestros Clientes" ya está publicado
// (o en el dispositivo con el token de vista previa). Antes solo existía
// en VuelosGuyanaPublicScreen; Yoedis reportó que no aparecía en la
// versión logueada de /vuelos-guyana porque nunca se agregó ahí.
import React, { useState, useEffect } from 'react';
import { estaVisiblePublicamente, resumenResenasPublico, getStoredPreviewToken } from '../services/nuestrosClientesService';

export default function TarjetaResenasClientes({ destino }) {
  const [visible, setVisible] = useState(false);
  const [resumen, setResumen] = useState(null);

  useEffect(() => {
    estaVisiblePublicamente().then((v) => {
      setVisible(v);
      if (v) resumenResenasPublico().then(setResumen);
    });
  }, []);

  if (!visible) return null;

  const ir = () => {
    const preview = getStoredPreviewToken();
    if (!preview) { window.location.href = destino; return; }
    window.location.href = `${destino}${destino.includes('?') ? '&' : '?'}preview=${preview}`;
  };

  return (
    <button onClick={ir} style={{
      margin: '8px 16px 0', padding: '10px 12px', borderRadius: 12,
      background: 'var(--navy-card)', border: '1px solid rgba(255,184,0,0.35)',
      display: 'flex', alignItems: 'center', gap: 8, width: 'calc(100% - 32px)', overflow: 'hidden',
    }}>
      <span aria-hidden="true" style={{ fontSize: 15, flexShrink: 0 }}>✈️</span>
      <span style={{ flex: 1, textAlign: 'left', minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 12.5, fontWeight: 700, color: 'var(--white)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          Así viajan nuestros clientes
        </span>
        {resumen && resumen.total > 0 && (
          <span style={{ display: 'block', fontSize: 11, color: 'var(--off-white, var(--muted))', marginTop: 2, lineHeight: 1.3 }}>
            {/* Cinco estrellas dibujadas (llenas según la nota redondeada) + "4,8 de 5" para que se entienda que es una calificación */}
            <span aria-hidden="true" style={{ letterSpacing: 1, marginRight: 4 }}>
              {[1, 2, 3, 4, 5].map((n) => (
                <span key={n} style={{ color: n <= Math.round(resumen.promedio) ? 'var(--gold, #FFB800)' : 'var(--navy-border, #3a4a66)' }}>★</span>
              ))}
            </span>
            <strong style={{ color: 'var(--white)' }}>{resumen.promedio.toFixed(1).replace('.', ',')} de 5</strong>
            {' · '}{resumen.total} opinion{resumen.total !== 1 ? 'es' : ''} de cliente{resumen.total !== 1 ? 's' : ''}
          </span>
        )}
      </span>
      <span style={{ flex: 'none', maxWidth: 86, textAlign: 'right', lineHeight: 1.25, fontSize: 11, fontWeight: 700, color: 'var(--gold, #FFB800)' }}>Ver fotos y opiniones →</span>
    </button>
  );
}
